import { getUserKey, loadSession } from '../../utils/actionStore';

export function getWorkspaceActionSummary(moduleId, authUser, limit = 24) {
  const session = loadSession(getUserKey(authUser));
  const nodes = Array.isArray(session?.nodes) ? session.nodes : [];
  return nodes
    .filter((node) => node?.module === moduleId)
    .slice(-limit)
    .map((node) => ({
      type: node.type,
      label: node.label,
      group: node.group,
      replayable: Boolean(node.replayable),
      ts: node.ts,
    }));
}
